import { Button } from "@/components/ui/button";
import { AlertTriangle, Home, RefreshCw } from "lucide-react";
import { useTranslation } from "react-i18next";

interface Error500Props {
  resetErrorBoundary?: () => void;
}

export function Error500({ resetErrorBoundary }: Error500Props) {
  const { t } = useTranslation();

  return (
    <div
      data-qa-id="error-500"
      className="flex min-h-screen w-full flex-col items-center justify-center bg-background p-4 text-center animate-in fade-in zoom-in duration-300"
    >
      <div className="relative mb-8 flex h-24 w-24 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/30">
        <div className="absolute h-full w-full rounded-full animate-ping bg-red-100 opacity-75 dark:bg-red-900/20" />
        <AlertTriangle className="h-12 w-12 text-destructive" />
      </div>

      <div className="space-y-2 max-w-[600px]">
        <h1 className="text-4xl font-extrabold tracking-tight lg:text-5xl text-foreground">
          {t("error500.title")}
        </h1>
        <h2 className="text-xl font-semibold text-muted-foreground">
          {t("error500.subtitle")}
        </h2>
        <p className="text-muted-foreground pt-2">
          {t("error500.description")}
        </p>
      </div>

      <div className="mt-8 flex flex-col gap-4 sm:flex-row">
        {resetErrorBoundary && (
          <Button
            data-qa-id="error-500-retry"
            onClick={resetErrorBoundary}
            size="lg"
            className="gap-2 min-w-[140px]"
          >
            <RefreshCw className="h-4 w-4" />
            {t("error500.tryAgain")}
          </Button>
        )}
        <Button
          data-qa-id="error-500-home"
          onClick={() => (window.location.href = "/")}
          variant="outline"
          size="lg"
          className="gap-2 min-w-[140px]"
        >
          <Home className="h-4 w-4" />
          {t("error500.goHome")}
        </Button>
      </div>

      <div className="mt-12 text-xs text-muted-foreground/50">
        {t("error500.errorCode", "Error code")}: 500 • INTERNAL_SERVER_ERROR
      </div>
    </div>
  );
}
